import { render, staticRenderFns } from "./CardFlip.vue?vue&type=template&id=7c22f0ee&scoped=true&"
import script from "./CardFlip.vue?vue&type=script&lang=js&"
export * from "./CardFlip.vue?vue&type=script&lang=js&"
import style0 from "./CardFlip.vue?vue&type=style&index=0&id=7c22f0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22f0ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
